import { Routes } from '@angular/router';
import { HelpUrls } from '../../../common/dto/help-urls';
import { DEFAULT_LANGUAGE } from '../../../common/dto/languages.dto';

export const routes: Routes = [
  {
    path: HelpUrls.relativeUrl,
    children: [
      {
        path: HelpUrls._.Home.relativeUrl,
        loadComponent: () => import('./home/home.component').then(_ => _.HomeComponent),
        pathMatch: 'full',
      },
      {
        path: HelpUrls._.Articles.relativeUrl,
        loadComponent: () => import('./articles/articles.component').then(_ => _.ArticlesComponent),
      },
      {
        path: HelpUrls._.NotFound.relativeUrl,
        loadComponent: () => import('./not-found/not-found.component').then(_ => _.NotFoundComponent),
      },
      {
        path: '**',
        redirectTo: HelpUrls._.Home.relativeUrl,
      },
    ],
  },
  {
    path: '**',
    redirectTo: HelpUrls.getAbsoluteUrlWithParams({
      [HelpUrls.params.language]: DEFAULT_LANGUAGE,
    }),
  },
];
